import { withInstall } from '../../../utils/with-install'
import LinkLayer from './LinkLayer.vue'

export const ElAmapLocaLink = withInstall(LinkLayer)
export default ElAmapLocaLink
